module.exports = __webpack_public_path__ + "img/faq-illustrations.5b37b049.svg";